<template>
  <div class="container-fluid">
    <div class="vld-parent row pb-4 pr-0" :class="deploymentBgClass" :id="$id('calendar')" ref='calendarContainer'>

      <div
        class="col px-0 calendarWeekGrid"
        :id="$id('mainCal')">
        <div :class="($mq == 'xs' || $mq == 'sm') ? 'container-fluid px-1' : 'container px-0'">
          <div :class="darkenCalendarBg ? 'bgDarker' : ''">
            <div v-if="bookingTypes.length > 1" :class="($mq == 'sm' || $mq == 'xs') ? 'container-fluid px-0' : 'container px-0'">
              <div class="btn-group-toggle text-center" data-toggle="buttons">
                <label v-for="bookingType in bookingTypes" class="calendarWeekGrid_Button_PrevNext" @click="toggleSelectedBookingTypes(bookingType)">
                  <input type="checkbox" v-model="selectedBookingTypes" :checked="selectedBookingTypes.includes(bookingType)" :value="bookingType"> {{ bookingType }}
                </label>
              </div>
            </div>

            <div class="row pt-4" v-if="showHeaderTitle">
              <div class="col text-center">
                <h2 class="font-weight-bold calendarWeekGrid_Header_Title">
                  <template v-if="axeThrowing">
                    Available Axe Throwing At {{ location.name }}
                  </template>
                  <template v-if="$deploymentIs('operationescape')">
                    Booking opening soon&hellip;
                  </template>
                  <template v-else>
                    {{ roomsAvailable[date.format('YYYY-MM-DD')] && roomsAvailable[date.format('YYYY-MM-DD')].length ? roomsAvailable[date.format('YYYY-MM-DD')].length : '' }} Games With Availability for {{ location.name }}
                  </template>
                </h2>
              </div>
            </div>

            <booking-calendar-sub-component-date-selection-header
              :date="date"
              @date-changed-on-header="changeDate"
              ></booking-calendar-sub-component-date-selection-header>

            <div v-for="roomsGrouped in openRoomsGroupedFiltered" class="calendar-cards-container">
              <template v-if="maximumSlotsInThisDay">
                <div v-for="room in roomsGrouped" class="calendarCardCellContainer" :key="room.id">
                  <div class="calendarCardCellWrapper">

                    <div class="calendarCardImgContainer">
                      <img id="room_mp" :src="'/img/mp/mp-ls-' + room.nickname + '.jpg'" class="booking-calendar-ls-mp">
                    </div>

                    <div class="card-content">
                      <h3 class="card-experience-title">{{ room.name }}</h3>
                      <p class="card-experience-topline">{{ room.top_title }}</p>

                      <hr class="card-content-separator"/>

                      <div class="card-booking-times-container">
                        <template v-if="roomSlotsForDate[room.id].length"> <!-- are there any slots? -->
                          <div
                            v-for="roomSlot in roomSlotsForDate[room.id]"
                            :key="roomSlot.id"
                            class="card-booking-time-button-wrapper"
                            @click.prevent="roomSlotClicked(roomSlot)">
                            <button class="card-booking-time-button" :class="calendarCell(roomSlot).class">
                              <p class="mb-2">
                                <span class="card-booking-time">{{ roomSlot.start | moment('h:mm') }}</span> <small>{{ roomSlot.start | moment('a') }}</small>
                              </p>
                              <span class="card-booking-state" v-html="calendarCell(roomSlot).text"></span>
                            </button>
                          </div>
                        </template>
                        <template v-else>
                          <button class="card-booking-no-time-button card-booking-time-button-no-slots">No Slots Remaining</button>
                          <button class="card-booking-no-time-button" @click.prevent="otherRoomClicked(room)">See Week's Calendar</button>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div v-else>
                <p>There are currently no RoomSlots set up for this time period. <span v-if="$deploymentIs('cryptology')" class="font-weight-bold"><br>Cryptology is closed on a Tuesday. With advanced notice we may be able to secure you a booking.</span></p>
                <p v-if="$deploymentIs('horrorescape')">Please email the branch at <a :href="'mailto:' + location.email + '?subject=Enquiry about future availability'" class="text-white font-weight-bold">{{ location.email }}</a>
                <p v-else-if="$deploymentIs('housetrap')">Sorry, no availability today as we are closed.</a>
                <p v-else-if="$deploymentIn(['topescaperooms'])"></p>
                <p v-else>Please contact the branch on <a :href="'tel:' + location.telephone" class="text-white font-weight-bold">{{ location.telephone }}</a> or email <a :href="'mailto:' + location.email + '?subject=Enquiry about future availability'" class="text-white font-weight-bold">{{ location.email }}</a></p>
              </div>
            </div>

            <div v-if="bookingTypes.length > 1" :class="($mq == 'sm' || $mq == 'xs') ? 'container-fluid px-0' : 'container px-0'">
              <div class="mt-4 btn-group-toggle text-center" data-toggle="buttons">
                <label v-for="bookingType in bookingTypes" class="calendarWeekGrid_Button_PrevNext" @click="toggleSelectedBookingTypes(bookingType)">
                  <input type="checkbox" v-model="selectedBookingTypes" :checked="selectedBookingTypes.includes(bookingType)" :value="bookingType"> {{ bookingType }}
                </label>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    consoleDebug: {
      type: Boolean,
      default: false,
    },
    initialCart: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    date: {
      type: Object,
      required: true,
    },
    saleFrom: {
      type: String,
      default: 'R',
    },
    locationDiscount: {
      type: Object,
    },
    roomSlots: {
      type: [Object, Array],
    },
    roomsAvailable: {
      type: [Object, Array],
    },
    brand: {
      type: String,
    },
    maxPerRow: {
      type: Number,
      default: 5,
    },
    locationChildPricing: {
      type: Boolean,
    },
    adultPricingNotPlayerPricing: {
      type: Boolean,
    },
    customerRequestMarketingPermission: {
      type: Boolean,
    },
    showCallToBookAsSold: {
      type: Boolean,
      default: false,
    },
    showDuration: {
      type: Boolean,
      default: false,
    },
    showPlayers: {
      type: Boolean,
      default: false,
    },
    useShortRoomName: {
      type: Boolean,
      default: true,
    },
    deploymentBgClass: {
      type: String,
    },
    bookingLabelStateLocked: {
      type: String,
      default: 'Reserved',
    },
    bookingLabelStateBooked: {
      type: String,
      default: 'Sold',
    },
    showHeaderTitle: {
      type: Boolean,
      default: true,
    },
    darkenCalendarBg: {
      type: Boolean,
      default: true,
    },
    showOtherAvailableGamesButtons: {
      type: Boolean,
      default: true,
    },
    showMainCalButton: {
      type: Boolean,
      default: true,
    },
    bookingHideSold: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      cart: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialCart))),

      axeThrowing: false, // this is not the way to do this, and this needs tackling when everything else is working

      selectedBookingTypes: [],
    };
  },

  computed: {
    /* ===============
     * timeslotCal computed
     */
    roomSlotsForDate() {
      let roomSlotsByRoom = [];

      if (this.roomSlots[this.date.format('YYYY-MM-DD')]) {
        if (this.bookingHideSold) {
          this.location.rooms.forEach(room => {
            roomSlotsByRoom[room.id] = this.roomSlots[this.date.format('YYYY-MM-DD')].filter(rs => rs.room_id == room.id && rs.state != 'BOOKED' && rs.state != 'UNSOLD' && rs.state != 'HIDDEN');
          });
        } else {
          this.location.rooms.forEach(room => {
            roomSlotsByRoom[room.id] = this.roomSlots[this.date.format('YYYY-MM-DD')].filter(rs => rs.room_id == room.id);
          });
        }
      }

      return roomSlotsByRoom;
    },

    maximumSlotsInThisDay() {
      // how many rows we need to render
      let maxSlot = 0;

      if (this.roomSlotsForDate) {
        this.roomSlotsForDate.forEach(rs => maxSlot = Math.max(maxSlot, rs.length));
      }

      return maxSlot;
    },

    openRooms() {
      if (this.$deploymentIs('dreadlockescape')) {
        return this.location.rooms.filter(room => room.badge != 'SOON' && room.type_title != 'Mobile');
      }
      return this.location.rooms.filter(room => room.badge != 'SOON');
    },

    bookingTypes() {
      if (this.openRooms.length) {
        return [...new Set(this.openRooms.map(r => r.type_title))];
      }
      return [];
    },

    showRoomType() {
      if (Object.keys(this.bookingTypes).length > 1) {
        return true;
      }
      return false;
    },

    todayDateString() {
      return moment().format('YYYY-MM-DD');
    },

    promoDate() {
      if (this.locationDiscount) {
        return moment(this.locationDiscount.date).format('YYYY-MM-DD');
      } else {
        return "N/A";
      }
    },

    openRoomsGrouped() {
      let roomGroup = [];
      this.openRooms.sort((a, b) => a.display_order - b.display_order);
      var rows = Math.ceil(this.openRooms.length / this.maxPerRow);
      var columns = Math.ceil(this.openRooms.length / rows);

      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < columns; c++) {
          if (((r*columns) + c) < this.openRooms.length) {
            roomGroup[r] = (typeof roomGroup[r] != 'undefined') ? roomGroup[r] : [];
            roomGroup[r].push(this.openRooms[(r*columns) + c]);
          }
        }
      }
      return roomGroup;
    },

    openRoomsGroupedFiltered() {
      let roomGroup = [];
      var filteredOpenRoomsGroups = this.openRooms.filter(r => this.selectedBookingTypes.includes(r.type_title)).sort((a, b) => a.display_order - b.display_order);
      if (this.$deploymentIs('breakescape')) {
        filteredOpenRoomsGroups = filteredOpenRoomsGroups.filter(r => r.slug != 'academy-of-spells');
      }
      // var rows = Math.ceil(filteredOpenRoomsGroups.length / this.maxPerRow);
      var columns = filteredOpenRoomsGroups.length;
      var r = 0;
      for (var c = 0; c < filteredOpenRoomsGroups.length; c++) {
        if (((r*columns) + c) < filteredOpenRoomsGroups.length) {
          roomGroup[r] = (typeof roomGroup[r] != 'undefined') ? roomGroup[r] : [];
          roomGroup[r].push(filteredOpenRoomsGroups[(r*columns) + c]);
        }
      }
      return roomGroup;
    },

    /*
     * END timeslotCal methods
     * =============== */

    roomSlotIdsInCart() {
      let roomSlotIds = [];

      if (this.cart && this.cart.cart_items) {
        this.cart.cart_items.forEach(cartItem => {
          if (cartItem.cartable_type == 'App\\Models\\RoomSlot') {
            roomSlotIds.push(cartItem.cartable_id);
          }
        });
      }

      return roomSlotIds;
    },
  },

  watch: {
    initialCart: {
      handler(newCart) {
        // console.log('BookingCalendarSubComponentAllRoomsCards::watch initialCart', newCart);
        this.cart = newCart;
      },
      deep: true,
    },
  },

  methods: {
    toggleSelectedBookingTypes(type) {
      if (this.selectedBookingTypes.includes(type)) {
        var index = this.selectedBookingTypes.findIndex(sbt => sbt == type);
        Vue.delete(this.selectedBookingTypes, index);
      } else {
        this.selectedBookingTypes.push(type);
      }
    },

    /* ===============
     * mainCal methods
     */

    changeDate(newDate) {
      this.$emit('date-changed', newDate);
    },

    calendarCell(roomSlot) {
      var theClass = '';
      var theText = '';
      if (this.roomSlotIdsInCart.includes(roomSlot.id)) {
        // if the slot is in the cart, this is what should be displayed
        theClass = 'inCart';
        theText = 'In Cart';
      } else if (roomSlot.state == 'AVAILABLE') {
        // slot is available
        if (this.checkCallToBook(roomSlot)) {
          if (this.showCallToBookAsSold) {
            theClass = 'state-booked';
            theText = '&nbsp;' + this.bookingLabelStateBooked + '&nbsp;';
          } else {
            theClass = 'state-available-c2b';
            theText = this.location.booking_options.c2b_calendar_title;
          }
        } else {
          theClass = 'state-available';
          if (roomSlot.public_booking) {
            theText = roomSlot.availableRemainingTickets + '/' + (roomSlot.override_play_max ? roomSlot.override_play_max : this.location.rooms.find(r => r.id == room_id).play_max) + ' Available';
          } else {
            theText = 'Available';
          }
        }
      } else {
        if (roomSlot.state == 'LOCKED' || roomSlot.state == 'BOOKED_PENDING') {
          theClass = 'state-locked';
          theText = this.bookingLabelStateLocked;
        } else if (roomSlot.state == 'BOOKED_PART') {
          theClass = 'state-available-part';
          theText = roomSlot.availableRemainingTickets + '/' + (roomSlot.override_play_max ? roomSlot.override_play_max : this.location.rooms.find(r => r.id == room_id).play_max) + ' Available';
        } else {
          theClass = 'state-booked';
          theText = this.bookingLabelStateBooked;
        }
      }
      return {
        class: theClass,
        text: theText,
      };
    },

    isMonthDaySelectable(dayInMonth) {
      let theDate = this.date.clone().date(dayInMonth);

      if (theDate < moment().date()
        || ! ([theDate.format('YYYY-MM-DD')] in this.roomSlots)
        || ([theDate.format('YYYY-MM-DD')] in this.roomSlots && (! ([theDate.format('YYYY-MM-DD')] in this.roomsAvailable)))
      ) {
        return false; // want a span, not a button
      }

      return true; // get a button, not a span
    },

    selectDayInMonth(dayInMonth) {
      this.date = this.date.clone().date(dayInMonth);
    },

    isMonthDayFullyBooked(dayInMonth) {
      // there are bookings, and none are available
      let theDate = this.date.clone().date(dayInMonth);

      if (theDate < moment().date()) {
        return false;
      }

      if (! ([theDate.format('YYYY-MM-DD')] in this.roomSlots)) {
        return false;
      }

      return ! ([theDate.format('YYYY-MM-DD')] in this.roomsAvailable);
    },

    isMonthDayFullyBookedandCryptology(dayInMonth) {
      if (this.$deploymentIs('cryptology')) {
        return this.isMonthDayFullyBooked(dayInMonth);
      }

      return false;
    },

    changeQueryString(param, value) {
      let url = new URL(window.location);
      url.searchParams.set(param, value);
      let state = {[param]: value};
      history.pushState(state, '', url);
    },

    /*
     * END mainCal methods
     * =============== */

    /* ===============
     * timeslotCal methods
     */

    slotClickable(roomSlot) {
      switch (roomSlot.state) {
        case 'LOCKED':
        case 'AVAILABLE':
        case 'BOOKED_PENDING':
        case 'BOOKED_PART':
          return true;
        case 'BOOKED':
        case 'HIDDEN':
        case 'UNSOLD':
        case 'DELETED':
        default:
          return false;
      }
    },

    slotStateClass(roomSlot) {
      switch (roomSlot.state) {
        case 'LOCKED':
        case 'BOOKED_PENDING':
          return 'timeSlotCalLocked';
        case 'BOOKED':
        case 'HIDDEN':
        case 'UNSOLD':
        case 'DELETED':
          return 'timeSlotCalBooked';
        case 'AVAILABLE':
        case 'BOOKED_PART':
          return 'timeSlotCalNotBookedCal';
        default:
          return '';
      }
    },

    slotStateStringForDisplay(roomSlot) {
      switch (roomSlot.state) {
        case 'HIDDEN':
        case 'UNSOLD':
          return 'Booked'
        default:
          return roomSlot.state_string;
      }
    },

    roomFor(roomSlot) {
      return this.location.rooms.find(room => room.id == roomSlot.room_id);
    },

    roomSlotClicked(roomSlot) {
      if (this.consoleDebug) console.log('BookingCalendarSubComponentAllRoomsCards::roomSlotClicked', roomSlot);

      if (this.slotClickable(roomSlot) === false) {
        return false;
      }
      if (this.checkCallToBook(roomSlot)) {
        if (this.showCallToBookAsSold) {
          // do nothing
        } else {
          this.$emit('show-call-to-book', roomSlot);
          if (this.consoleDebug) console.log('BookingCalendarSubComponentAllRoomsCards::roomSlotClicked - emitted show-call-to-book RoomSlot');
        }
      } else {
        if ('LOCKED' == roomSlot.state || 'BOOKED_PENDING' == roomSlot.state) {
          this.$emit('attempt-to-unlock-slot', roomSlot);
          if (this.consoleDebug) console.log('BookingCalendarSubComponentAllRoomsCards::roomSlotClicked - emitted attempt-to-unlock-slot RoomSlot');
        } else {
          this.$emit('add-room-slot-to-pre-cart', roomSlot);
          if (this.consoleDebug) console.log('BookingCalendarSubComponentAllRoomsCards::roomSlotClicked -emitted add-room-slot-to-pre-cart RoomSlot');
        }
      }
    },

    checkCallToBook(roomSlot) {
      return moment(roomSlot.start).subtract(this.location.booking_minutes, 'minutes') < moment() || roomSlot.call_to_book != 'NO';
    },

    openModalRoomSlotNotAvailable() {
      // console.log('openModalRoomSlotNotAvailable()');
      this.$refs.makeBooking.hideAllModals();
      this.$refs.roomSlotUnavailable.showModal();
    },

    /*
     * END timeslotCal methods
     * =============== */

    /* ===============
     * Echo methods
     */

    otherRoomClicked(room) {
      if (this.consoleDebug) console.log('BookingCalendarSubComponentAllRoomsCards::otherRoomClicked', room);
      // probably want a bool Meta|Option here to state what to do for the calendar
      // Option 1) change this iFrame view to that Room
      // Option 2) redirect to that page
      // TODO: the below if statement
      if (true) {
        this.$emit('differing-calendar-clicked', room);
      } else {
        window.location.href = locationRoomRoute(room.id, this.date.format('YYYY-MM-DD')) + '#book';
      }
    },

    locationRoomRoute(room_id, date) {
      let room = this.location.rooms.find(room => room.id == room_id);

      if (this.$deploymentIn([
        'cryptology',
        'breakescape',
        'topescaperooms',
        'panicroomharlow',
        'axefactor',
        'escaporium',
        'm4escapes',
        'mysteryquests',
        'escapetime',
        'operationescape',
        'cluehqsomerton',
      ])) {
        return this.route(this.$deploymentCurrent + '.location.room', {location: this.location, room: room, dt: date});
      }

      return this.route(this.$deploymentCurrent + '.room', {room: room, dt: date});
    },

    /*
     * END Echo methods
     * =============== */

    range(start, end) { // this is for a v-for, it cannot not start at 0, vueIdiots
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },
  },

  mounted() {
    this.selectedBookingTypes = JSON.parse(JSON.stringify(this.bookingTypes));
  },

  beforeDestroy() {

  },
}
</script>
